import React from "react"
import PropTypes from "prop-types"
import {Box} from "@mui/material"
import ButtonWithIcon from "../../../../components/Button/Button"
import { ReactComponent as CopyIcon } from "src/v2/assets/icons/copy-icon.svg"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import { ReactComponent as SaveIcon } from "src/v2/assets/icons/download-cloud-icon.svg"
import { ReactComponent as CloseSquareIcon } from "src/v2/assets/icons/close-square-icon.svg"
import { ReactComponent as ArrowLeftIcon } from "src/v2/assets/icons/arrow-left-icon.svg"
import DuplaConfirmacao from "src/v2/components/DuplaConfirmacao/DuplaConfirmacao"
import { Divider } from "@mui/material"

const FormActions = ({
    onBack,                
    showBack = false, 
    onDelete,
    onDuplicate,
    onSave,
    onPublish,
    onConfirmPublish,
    onConfirmDelete,
    publishOpen,
    deleteOpen,
    setPublishOpen,
    setDeleteOpen,
    showSave = true,
    publishLabel = "PUBLICAR",
    publishIcon = <CheckIcon/>,
}) => {
    return (
        <>
            <Box
                sx={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: "calc(100% - 208px)",
                    marginLeft: "209px",
                    alignSelf: "stretch",
                    zIndex: 10,
                    backgroundColor: "#4c526a",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                    py: 4,
                    px: {xxxs: 2, md: 3}, // alinhar com padding do miolo e largura da sidebar
                    flexWrap: "wrap",
                    alignItems: "center",
                    borderRadius: 0,
                    "@media (max-width: 1100px)": {
                        width: "100%",
                        marginLeft: 0,
                        px: 2,
                    },
                }}
            >
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center" }}>
                    {showBack && (
                        <>
                            <ButtonWithIcon
                                size="md"
                                icon={<ArrowLeftIcon />}
                                onClick={onBack}
                            >
                                VOLTAR
                            </ButtonWithIcon>

                            <Divider
                                orientation="vertical"
                                flexItem
                                sx={{
                                    borderColor: "rgba(255,255,255,0.4)",
                                }}
                            />
                        </>
                    )}

                    <ButtonWithIcon
                        size="md"
                        icon={<CloseSquareIcon />}
                        onClick={onDelete}
                    >
                        DELETAR
                    </ButtonWithIcon>
                </Box>

                <Box sx={{display: "flex", gap: 2, flexWrap: "wrap"}}>
                    <ButtonWithIcon size="md" icon={<CopyIcon style={{}}/>} onClick={onDuplicate}>
                        DUPLICAR
                    </ButtonWithIcon>
                    {showSave && (
                        <ButtonWithIcon size="md" icon={<SaveIcon />} onClick={onSave}>
                            SALVAR
                        </ButtonWithIcon>
                    )}
                    <ButtonWithIcon size="md" icon={publishIcon} onClick={onPublish}>
                        {publishLabel}
                    </ButtonWithIcon>
                </Box>
            </Box>
            <DuplaConfirmacao
                open={publishOpen}
                cancel={() => setPublishOpen(false)}
                confirm={() => onConfirmPublish?.()}
                title="Publicar"
                description="Certifique-se de corrigir todos os campos antes de publicar um Documento."
                confirmTextButton="Publicar"
            />
            <DuplaConfirmacao
                open={deleteOpen}
                cancel={() => setDeleteOpen(false)}
                confirm={() => onConfirmDelete?.()}
                title="Deletar Cadastro"
                description="Esta ação removerá o cadastro. Confirme para prosseguir."
                confirmTextButton="Deletar"
            />
        </>
    )
}

FormActions.propTypes = {
    onBack: PropTypes.func,
    showBack: PropTypes.bool,
    onDelete: PropTypes.func,
    onDuplicate: PropTypes.func,
    onSave: PropTypes.func,
    onPublish: PropTypes.func,
    onConfirmPublish: PropTypes.func,
    onConfirmDelete: PropTypes.func,
    publishOpen: PropTypes.bool,
    deleteOpen: PropTypes.bool,
    setPublishOpen: PropTypes.func,
    setDeleteOpen: PropTypes.func,
    showSave: PropTypes.bool,
    publishLabel: PropTypes.string,
    publishIcon: PropTypes.node,
}


export default FormActions
